import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { PiShootingStarFill } from "react-icons/pi";
import { FaArrowLeft } from "react-icons/fa";
import { StepsContainerStyled } from "../../../../styled/Resume";
import EducationCard from "../../Tools/EducationCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const EducationInfo = (props) => {
  const {
    step,
    setStep,
    setStepData,
    eduArray,
    handleEduExpChange,
    handleDeleteEduInfo,
    handleAddEduInfo,
    eduInfoForwardOrBackward,
  } = props;

  const [disableFields, setDisableFields] = useState(true);
  const { themeName } = useTheme();

  // Sync eduArray into global stepData
  useEffect(() => {
    setStepData((prev) => ({
      ...prev,
      educationInfo: eduArray,
    }));
  }, [eduArray, setStepData]);

  // Validate all required education fields
  useEffect(() => {
    const isValid = eduArray.every(
      (edu) =>
        edu.institution?.trim() !== "" &&
        edu.degree?.trim() !== "" &&
        edu.date?.trim() !== ""
    );
    setDisableFields(!isValid);
  }, [eduArray]);

  const handleClick = (e) => {
    if (e) e.preventDefault();
    eduInfoForwardOrBackward("forward");
    if (!disableFields) {
      setStep(step + 1);
    }
  };

  return (
    <StepsContainerStyled theme={themeName}>
      <h2>
        Education Information <span>(most recent first)</span>
      </h2>
      <div className="educationInfo">
        <EducationCard
          eduArray={eduArray}
          handleEduExpChange={handleEduExpChange}
          handleDeleteEduInfo={handleDeleteEduInfo}
          handleAddEduInfo={handleAddEduInfo}
        />
      </div>
      <div className={step > 1 ? "btnS" : "btn"}>
        <Button
          justifycontent="start"
          secondaryLight
          width="100%"
          clickHandle={() => setStep((prev) => prev - 1)}
        >
          <FaArrowLeft />
          Previous
        </Button>
          <div className="nextBtnWrap">
            <Button
              justifycontent="flex-end"
              primary
              width="100%"
              clickHandle={handleClick}
              disabled={disableFields}
            >
              Experiences
              <PiShootingStarFill />
            </Button>
          </div>
      </div>
    </StepsContainerStyled>
  );
};

export default EducationInfo;